/* eslint-disable no-use-before-define */
/* eslint-disable no-confusing-arrow */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import { set, setCustomer, setIsLoadingLoaded, clear, clearSelectedFilters, selectFilterItem, unselectFilterItem } from './actions';
import { fetchLinesAggsFilters } from '../../../api/linesaggsfilters';
import { selectCtsFilterItems, selectCustomer, selectCustomersFilterItems, selectEntitiesFilterItems, selectFilterItems, selectJobFilterItems, selectLineFilterItems, selectPmsFilterItems, selectSelectedFiltersMap, selectSurveyTypesFilterItems, selectTagsFilterItems } from '../selectors';
import { thunkSetSearchText } from '../../LinesAggsFilterTextSearch/actions';
import UTIL from '../util.selectedFilters';
import LADF_UTIL from '../util.urlWriter';
import FALLBACK_URL_FILTERS_UTIL from '../util.legacy.fallbackUrlFilters';



const thunkLoad = () => (dispatch, getState) => {
  const customerName = selectCustomer(getState());

  dispatch(clear());
  dispatch(setCustomer(customerName));
	dispatch(
		setIsLoadingLoaded({
			isLoading: true,
			isLoaded: false
		})
	);
  fetchLinesAggsFilters(customerName).then((filters) => {
		dispatch(set(filters));
    dispatch(
      setIsLoadingLoaded({
        isLoading: false,
        isLoaded: true
      })
    );
    dispatch(thunkLoadStateFromUrl());
    dispatch(thunkExecuteFallbackUrlFilters());
	});
};

const thunkSetCustomerName = (customerName) => (dispatch) => { 
  dispatch(setCustomer(customerName));
  dispatch(clearSelectedFilters());
  dispatch(thunkLoad());
}

const thunkClearSelectedFilters = () => (dispatch) => { 
  dispatch(clearSelectedFilters());
  LADF_UTIL.clearUrl();
}

const thunkUnselectFilterItem = (filterKey, item, { preventUrlWrite = false } = {}) => (dispatch, getState) => { 
  const selectedFiltersMap = selectSelectedFiltersMap(getState());
  const currIsSelected = UTIL.computeIsFilterItemSelected(filterKey, item, selectedFiltersMap)
  if (currIsSelected) {
    dispatch(unselectFilterItem(filterKey, item));
    if (!preventUrlWrite) {
      LADF_UTIL.removeFromUrl(filterKey, item);
    }
  }
}

const thunkSelectFilterItem = (filterKey, item, { preventUrlWrite = false } = {}) => (dispatch, getState) => { 
  const selectedFiltersMap = selectSelectedFiltersMap(getState());
  const currIsSelected = UTIL.computeIsFilterItemSelected(filterKey, item, selectedFiltersMap)
  if (!currIsSelected) {
    dispatch(selectFilterItem(filterKey, item));
    if (!preventUrlWrite) {
      LADF_UTIL.addToUrl(filterKey, item);
    }
  }
}

const thunkToggleFilterItem = (filterKey, item) => (dispatch, getState) => { 
  const selectedFiltersMap = selectSelectedFiltersMap(getState());
  const currIsSelected = UTIL.computeIsFilterItemSelected(filterKey, item, selectedFiltersMap)
  if (currIsSelected) {
    dispatch(thunkUnselectFilterItem(filterKey, item));
  } else { 
    dispatch(thunkSelectFilterItem(filterKey, item));
  }
}

const thunkLoadStateFromUrl = () => (dispatch, getState) => { 
  if (!LADF_UTIL.CACHE.isLoaded) {
    LADF_UTIL.loadCacheFromUrl();
    const { FILTERS: URL_FILTERS } = LADF_UTIL.CACHE;
    const filterKeys = Object.keys(URL_FILTERS);

    filterKeys.forEach((filterKey) => {
      // identify selected ids
      const ids = URL_FILTERS[filterKey];
      const idsMap = ids.reduce((acc, id) => {
        acc[id] = true;
        return acc;
      }, {});

      // Map IDs to Existing Objects
      const possibleFilters = selectFilterItems(getState(), filterKey);
      const selectedFilters = possibleFilters.map(item => ((idsMap[item.id] && item) || undefined)).filter(v => v);
      selectedFilters.forEach(item => {
        dispatch(thunkSelectFilterItem(filterKey, item, { preventUrlWrite: true }));
      });
    });
  }
}

const _thunkSelectFilterItems = (filterKey, items = [], { preventUrlWrite = false } = {}) => (dispatch) => { 
  items.forEach(item => {
    dispatch(thunkSelectFilterItem(filterKey, item, { preventUrlWrite }));
  });
}

const thunkExecuteFallbackUrlFilters = () => (dispatch, getState) => {
  const {
    isEmpty,
    hasSettingEnableLinesListCardsView,
    shouldUpdateUrl,
    getUpdatedFiltersPayload,
    destroyLegacyFilterUrlParams,
  } = FALLBACK_URL_FILTERS_UTIL;

  if (shouldUpdateUrl()) {
    const availableFilters = {
      [UTIL.FILTER_KEYS.CUSTOMERS]: selectCustomersFilterItems(getState()),
      [UTIL.FILTER_KEYS.LINES]: selectLineFilterItems(getState()),
      [UTIL.FILTER_KEYS.JOBS]: selectJobFilterItems(getState()),
      [UTIL.FILTER_KEYS.ENTITIES]: selectEntitiesFilterItems(getState()),
      [UTIL.FILTER_KEYS.PMS]: selectPmsFilterItems(getState()),
      [UTIL.FILTER_KEYS.CTS]: selectCtsFilterItems(getState()),
      [UTIL.FILTER_KEYS.SURVEY_TYPES]: selectSurveyTypesFilterItems(getState()),      
      [UTIL.FILTER_KEYS.TAGS]: selectTagsFilterItems(getState()),      
    }
    const { searchText, newSelectedFilters } = getUpdatedFiltersPayload(availableFilters);

    // Set Search Text
    if (!isEmpty(searchText)) {
      dispatch(thunkSetSearchText(searchText))
    }

    // Set Dynamic Filter Dropdowns
    const filterKeys = Object.keys(newSelectedFilters);
    filterKeys.forEach(filterKey => { 
      const items = newSelectedFilters[filterKey] || [];
      dispatch(_thunkSelectFilterItems(filterKey, items, { preventUrlWrite: false }));
    })

    // Destroy Legacy Url Params
    if (!hasSettingEnableLinesListCardsView()) { 
      setTimeout(() => { destroyLegacyFilterUrlParams(); }, 300)
    }
  }
}



export {
  thunkClearSelectedFilters,
  thunkUnselectFilterItem,
  thunkSelectFilterItem,
  thunkLoad,
  thunkSetCustomerName,
  thunkToggleFilterItem
};
